import { INTERNAL_FORM_FIELD_TYPES } from 'components/modules/custom-pages/constants/form';

export const FIELDS_NOT_UNIQUE_ERROR_MESSAGE =
  'Please ensure that all field labels are both unique and not empty.';

export const FIELDS_EMPTY_ERROR_MESSAGE = 'Please ensure that at least one field is selected.';
export const HEADER_EMPTY_ERROR_MESSAGE = 'Header must not be empty.';
export const EMAIL_SUBJECT_EMPTY_ERROR_MESSAGE =
  'Please ensure that the email subject is not empty.';
export const CHANNEL_EMPTY_ERROR_MESSAGE = 'Channel is required';

export const MARKDOWN_TEXT_EMPTY_ERROR_MESSAGE =
  'Please ensure that every markdown text field has content.';

export const READ_ONLY_FIELDS = [INTERNAL_FORM_FIELD_TYPES.MarkdownText];
